"use client";

import type { ReactElement } from "react";
import "../../developers/_components/developers-funnel.css";
import "../../_components/careers.css";
import "../../_components/careers-redesign.css";
import "./engineering2.css";
import { CareersFooter } from "../../_components/careers-footer";
import { CareersLanguageProvider } from "../../_components/careers-language-context";
import { CareersProcessSection } from "../../_components/careers-process-section";
import { FUNNEL_CONTENT } from "../../developers/_components/developers-funnel-content";
import type { FunnelSection } from "../../developers/_components/developers-funnel-content";
import { DevelopersFunnelSection } from "../../developers/_components/developers-funnel-section";
import { DevelopersShipHeatmap } from "../../developers/_components/developers-ship-heatmap";
import { Engineering2Comparison } from "./engineering2-comparison";
import { Engineering2Hero } from "./engineering2-hero";
import { Engineering2JobsSection } from "./engineering2-jobs-section";
import { ENGINEERING_PROCESS } from "./engineering2-process-copy";
import { Engineering2SkipBlock } from "./engineering2-skip-section";
import { Engineering2Topbar } from "./engineering2-topbar";

/** Funnel stack band. Convex in the intro is a YouTube link (engineering only). */
const STACK_BASE: FunnelSection | undefined = FUNNEL_CONTENT.sections.find(
  (section) => section.id === "stack",
);

const STACK_SECTION: FunnelSection | undefined =
  STACK_BASE === undefined
    ? undefined
    : {
        ...STACK_BASE,
        introYoutube: {
          word: "Convex",
          href: "https://www.youtube.com/watch?v=O_HXVAMPEbc",
        },
      };

/**
 * Engineering careers page in the careers redesign system (dark canvas,
 * Inter, teal accents). English only. Visitors arrive from /careers, so
 * nothing from that page is repeated here: tech stack → shipping →
 * comparison → engineering jobs → process.
 */
export function Engineering2Page(): ReactElement {
  return (
    <CareersLanguageProvider initialLang="en">
      <div className="dvf c2 e2">
        <Engineering2Topbar />
        <Engineering2Hero />
        {STACK_SECTION ? (
          <div className="dvf-stack-ship">
            <DevelopersFunnelSection section={STACK_SECTION} flip={true} />
            <DevelopersShipHeatmap after={<Engineering2SkipBlock />} />
          </div>
        ) : null}
        <Engineering2Comparison />
        <Engineering2JobsSection />
        <CareersProcessSection process={ENGINEERING_PROCESS} />
        <CareersFooter />
      </div>
    </CareersLanguageProvider>
  );
}
